import { ChangeDetectionStrategy, Component, Input, Optional, Self } from '@angular/core';
import { AbstractControl, ControlValueAccessor, FormControl, NgControl } from '@angular/forms';
import { constants } from 'src/app/core/constants/constants';
import { ValidationErrorsService } from 'src/app/shared/services/validation-errors.service';

@Component({
  selector: 'app-textarea',
  templateUrl: './app-textarea.component.html',
  styleUrl: './app-textarea.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppTextareaComponent implements ControlValueAccessor {
  @Input() label: string | undefined;
  @Input() showErrors?: boolean = true;
  @Input() showCounter?: boolean = false;
  @Input() maxLength?: number;
  @Input() rowsCount?: number = 3;
  @Input() readonly = false;
  @Input() placeholder: string = '';
  @Input() highlightAsError?: boolean = false;
  @Input() name: string = '';
  @Input() id: string = '';

  public hide: boolean = false;

  get control(): FormControl {
    return this.ngControl?.control as FormControl;
  }

  get isRequired(): boolean {
    const validator = this.control.validator ? this.control.validator({} as AbstractControl) : null;
    return validator && validator['required'];
  }

  constructor(
    @Self() @Optional() public ngControl: NgControl,
    private validationErrorsService: ValidationErrorsService,
  ) {
    if (this.ngControl) {
      this.ngControl.valueAccessor = this;
    }
  }

  public getErrorMessage(): string {
    if (this.control?.invalid && this.control?.errors) {
      return this.validationErrorsService.getControlErrorMessage(this.control.errors);
    }
    return '';
  }

  onInputChange(event: any): void {
    this.control.markAsDirty();
    this.control.markAsTouched();
  }

  onChange: any = (value: string) => {};
  onTouched: any = () => {};

  public registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  public writeValue(value: any): void {}

  get counter(): string {
    let currentValueLength = (this.control?.value + '').length || 0;

    return `${currentValueLength}/${this.maxLength}`;
  }
}
